<div class="prompt-runner" *ngIf="runs.length > 0" role="region" aria-label="Prompt runs status">
  <div class="prompt-runner-header">
    <span class="title">
      <span nz-icon nzType="sync" nzTheme="outline" [class.spinning]="hasActiveRuns()" aria-hidden="true"></span>
      Prompt Runs
      <span class="run-count" *ngIf="runs.length > 1">{{ runs.length }}</span>
    </span>
  </div>

  <div class="prompt-runner-list" role="list">
    <div class="prompt-runner-item" *ngFor="let run of runs; trackBy: trackByExecutionId" 
      (click)="openPrompt(run)" (keydown.enter)="openPrompt(run)"
      role="listitem" tabindex="0"
      [attr.aria-label]="run.title + ' - ' + run.status">
      <div class="item-row">
        <div class="item-title">{{ run.title }}</div>
        <button type="button" class="close-btn" (click)="closeRun(run); $event.stopPropagation()"
          aria-label="Dismiss notification">
          <span nz-icon nzType="close" aria-hidden="true"></span>
        </button>
      </div>
      <div class="prompt-runner-progress">
        <div class="progress-bar-track" *ngIf="isIndeterminate(run)">
          <div class="progress-bar-fill" [class.pending]="run.status === 'Pending'" [class.running]="run.status === 'Running'"></div>
        </div>
        <nz-progress
          *ngIf="!isIndeterminate(run)"
          [nzPercent]="run.progress"
          [nzStatus]="run.status === 'Failed' ? 'exception' : (run.status === 'Completed' ? 'success' : 'active')"
          [nzShowInfo]="false">
        </nz-progress>
      </div>
      <div class="item-status" [class.status-completed]="run.status === 'Completed'" 
        [class.status-failed]="run.status === 'Failed'"
        [class.status-running]="isIndeterminate(run)">
        <span class="status-icon" nz-icon 
          [nzType]="getStatusIcon(run)" 
          [nzTheme]="run.status === 'Completed' || run.status === 'Failed' ? 'fill' : 'outline'"
          [nzSpin]="run.status === 'Running'"
          aria-hidden="true"></span>
        <span class="status-text">{{ getStatusText(run) }}</span>
        <span class="elapsed-time" *ngIf="getElapsedTime(run)">{{ getElapsedTime(run) }}</span>
      </div>
    </div>
  </div>
</div>
